/* eslint-disable object-curly-newline */
import React from 'react';
import { useSelector } from 'react-redux';

import {
  handleChange,
  handleValidation,
  getValidClass,
  isRequired,
  getFieldKey,
  fieldShouldDisplay,
} from '../../../../utils/form';

import FormLabel from './FormLabel';

function DatePicker({
  cols = '12',
  clone,
  disabled,
  name,
}) {

  const { values, form: { form } } = useSelector(store => store);
  const value = values[name];

  const required = isRequired({ form, name, currentValues: values });
  const validationRegex = useSelector(store => store.validation[name]);
  const defaultLabel = useSelector(store => store.labels[name]);
  const valid = useSelector(store => store.valid[name]);
  const validClass = getValidClass({ valid, required, value });

  const { submittedFlag } = useSelector(store => store.enrollment);
  const isDisabled = (disabled || clone || submittedFlag);

  const customLabel = getFieldKey(form, name, 'label');

  // if field doesn't exist, don't show it.
  if (!fieldShouldDisplay(form, name, values)) return null;

  return (
    <div className={`col-md-${cols}`}>
      <FormLabel name={name} label={customLabel || defaultLabel} required={required} />
      <input
        className={['form-control', (!isDisabled ? validClass : '')].join(' ')}
        type="date"
        id={name}
        onChange={(e) => handleChange({
          value: e.target.value,
          name,
          valid,
          validationRegex,
          required,
        })}
        value={values[clone || name] || ''}
        disabled={isDisabled}
        onBlur={(e) => {
          if (!e.target.value) e.target.value = '000-00-00';
          handleValidation({ value, validationRegex, name, required });
        }}
      />
    </div>
  );
}

export default DatePicker;
